import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from '@material-ui/core';

const USER_GOALS = [
  {
    value: 'feature-flags',
    label: 'Feature flags',
  },
  {
    value: 'rollouts',
    label: 'Rollouts',
  },
  {
    value: 'ab-testing',
    label: 'A/B testing',
  },
  {
    value: 'analyze-results',
    label: 'Analyze past experiments',
  },
  {
    value: 'other',
    label: 'Other',
  },
];
export const UserGoals = ({
  value,
  onChange,
}: {
  value: string[];
  onChange: (goals: string[]) => void;
}) => {
  const handleToggle = (goal: string, checked: boolean) => {
    onChange(checked ? [...value, goal] : value.filter(g => g !== goal));
  };

  return (
    <FormControl component="fieldset">
      <FormLabel required>
        Select your goals (you can select multiple)
      </FormLabel>
      {USER_GOALS.map(goal => (
        <FormControlLabel
          key={goal.value}
          control={
            <Checkbox
              color="primary"
              checked={value.includes(goal.value)}
              onChange={e => handleToggle(goal.value, e.target.checked)}
            />
          }
          label={goal.label}
        />
      ))}
    </FormControl>
  );
};
